import Swagger from 'swagger-client';

import {i18nStore} from "../stores/StoreLoader";
import {ExecutionEnvironment} from "../stores/InterfaceStore";
import {getConfig} from "../_configs/AppConfig";
import {getCookieFromString} from "../utils/StringUtilities";
const {publicRuntimeConfig} = getConfig();

function createSingleton(swaggerAuthorization?: Swagger.ApiKeyAuthorization): Swagger {
    const swag = {
        url: publicRuntimeConfig.API_SPEC_URL,
        usePromise: true,
        debug: false,
    }
    if (swaggerAuthorization) {
        // @ts-ignore
        swag.authorizations = {
            api_key: swaggerAuthorization,
        }
    }
    return new Swagger(swag);
}

let swaggerSingleton: Swagger | null = null;

export default function WatsonApi(token?: string) {
    const swaggerAuthorization = buildSwaggerAuthorization(token);

    if (!swaggerSingleton) {
        swaggerSingleton = createSingleton(swaggerAuthorization);
    }

    swaggerSingleton.then(client => {
        if (swaggerAuthorization) {
            client.clientAuthorizations.add("api_key", swaggerAuthorization);
        }
        client.clientAuthorizations.add("accept-language", new Swagger.ApiKeyAuthorization('accept-language', i18nStore.currentOrgSupportedLocale, 'header'));
    });

    return swaggerSingleton;
}

export function buildSwaggerAuthorization(token?: string) {
    if (!token && ExecutionEnvironment.canUseDOM) {
        token = getCookieFromString("token", document.cookie);
    }
    if (token) {
        return new Swagger.ApiKeyAuthorization('api-key', token, 'header');
    }
}
